<template>
    <div class="imports">
        <h1><i class="fa fa-file" /> IMPORTAÇÃO DE RETORNO</h1>
        <div class="mod">
            <div class="title row align-center justify-space">
                <div class="row align-center">PAGAMENTO
                    <button @click="tutorial = !tutorial" class="tut">Tutorial <i v-if="tutorial"
                            class="fa fa-chevron-up" /><i v-else class="fa fa-chevron-down" /></button>
                </div>
                <div class="row justify-space" style="width: 170px">
                    <Button @click="list('pagamento')" layout="green-go" :loader="loader">Listar</Button>
                    <Button @click="load('filesPagamento')" layout="green-go">Importar</Button>
                </div>
            </div>
            <div v-if="tutorial" class="tutorial">
                <div class="desc">
                    <b>Formato:</b> arquivo deve ser texto no formato CSV, usando ponto e vírgula ( <b>;</b> )
                    como separador de campos e aspas duplas ( <b>"</b> ) como delimitador de texto.<br />
                    <b>Campos:</b> arquivo deve conter obrigatóriamente os campos:
                    <ul>
                        <li><b>job_atendimento:</b> Deve conter id_job/id_atendimento</li>
                        <li><b>data_pagamento:</b> Data de pagamento no formato DD/MM/AAAA</li>
                        <li><b>valor_pagamento:</b> Valor pago no formato 0,00 ou 0.00</li>
                    </ul>
                    <b>Outros campos/colunas:</b> arquivo pode conter outros campos mas ele serão ignorados
                    <br><br>
                    <b>Linhas com erros: </b>arquivo não pode conter erros. Ao enviar um arquivo se houver falha
                    o arquivo não será processado. Será gerada uma lista com as linhas com erro indicando as
                    falhas ocorridas. O arquivo deve ter as linhas com erro corrigidas ou removidas e deve ser
                    enviado novamente.<br><br>
                    <b>Registros repetidos:</b>o sistema não verifica se um retorno de pagamento existente no
                    arquivo é repetido ou mesmo se já foi importado antes. O sistema simplesmente irá
                    sobrescrever a data de pagamento com a data informada no último arquivo de
                    importação.<br><br><b>Ex.</b> se alguém fizer uma importação hoje e nela tiver pagamento do job
                    1, atendimento 1 com data 01/01/2019 isso marcará a data de pagamento do atendimento com a
                    data 01/01/2019. Se alguns dias depois um novo arquivo for importado e contiver
                    <b>novamente</b> uma linha com job 1, atendimento 1 e data de pagamento 15/01/2019 este
                    atendimento passará ter a nova data de pagamento (15/01/2019) e anterior será perdida.
                </div>
            </div>
            <div v-if="filesPagamento.length" class="files">
                <div class="upload row align-center grid-12">Upload <Button :loader="loader"
                        v-if="filesPagamento.length > 0 && filesPagamento.filter(f => f.notallow).length == 0"
                        @click="submit('filesPagamento')" layout="green-go">ENVIAR</Button></div>
                <div v-for="(f, i) in filesPagamento" :key="i+'fp'" class="file row align-center">
                    <button @click="filesPagamento.splice(i, 1)" class="del" title="Excluir"><i
                            class="fa fa-trash" /></button>
                    <div v-if="!f.notallow" class="field grid-8 grid-6-s">
                        <div class="filler row justify-end" :style="`width: ${f.percent}%`"> {{ f.percent + "%" }}</div>
                    </div>
                    <div v-else class="notallow">{{ f.notallow && 'Formato de arquivo não permitido.' }}</div>
                    {{ f.name }}
                </div>
            </div>
            <div v-if="pagamento.length" class="list">
                <div class="head row">
                    <div class="grid-2">ID</div>
                    <div class="grid-3">Tipo</div>
                    <div class="grid-5">Criado</div>
                    <div class="grid-2"></div>
                </div>
                <div class="container">
                    <div v-for="p of pagamento" :key="p.id" class="line row align-center">
                        <div class="grid-2">{{ p.id }}</div>
                        <div class="grid-3">{{ p.tipo }}</div>
                        <div class="grid-5">{{ p.nome_criado_por }} em {{ p.criado_em | date }}</div>
                        <div class="grid-2 text-center"><Button layout="green-go" @click="open(p.id,'pagamento')"><i
                                    class="fa fa-file" />Baixar</Button></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mod">
            <div class="title row align-center justify-space">
                <div class="row align-center">FATURAMENTO
                    <button @click="tutorialFaturamento = !tutorialFaturamento" class="tut">Tutorial <i
                            v-if="tutorialFaturamento" class="fa fa-chevron-up" /><i v-else
                            class="fa fa-chevron-down" /></button>
                </div>
                <div class="row justify-space" style="width: 170px">
                    <Button @click="list('faturamento')" layout="green-go" :loader="loader">Listar</Button>
                    <Button @click="load('filesFaturamento')" layout="green-go">Importar</Button>
                </div>
            </div>
            <div v-if="tutorialFaturamento" class="tutorial">
                <div class="desc">
                    <b>Formato:</b> arquivo deve ser texto no formato CSV, usando ponto e vírgula ( <b>;</b> )
                    como separador de campos e aspas duplas ( <b>"</b> ) como delimitador de texto.<br />
                    <b>Campos obrigatórios:</b> arquivo deve conter obrigatóriamente os campos:
                    <ul>
                        <li><b>id_job:</b> id do job</li>
                        <li><b>data_emissao_nf:</b> Data de emissão da nota fiscal no formato DD/MM/AAAA</li>
                        <li><b>total_faturado:</b> Valor faturado do Job no formato 0.00 ou 0,00</li>
                        <li><b>NF:</b> Código da Nota Fiscal. Recomendado acrescentar letras para identificar
                            localidade de forma complementar ao seu número. NF deve ser <b>maiúsculo</b></li>
                        <li><b>iss:</b> Alíquota % imposto ISS sobre a NF faturada do job no formato 0.00 ou
                            0,00 (somente dígitos, sem %)</li>
                        <li><b>pis:</b> &nbsp;<b style="color:red">NÃO INFORMAR. SERÁ REGISTRADO AUTOMATICAMENTE
                                alíquota de 1,65%</b>
                        </li>
                        <li><b>cofins:</b> &nbsp;<b style="color:red">NÃO INFORMAR. SERÁ REGISTRADO AUTOMATICAMENTE
                                alíquota de 7,6%</b>
                        </li>
                        <li><b>ir:</b> Alíquota % imposto IR sobre a NF faturada do job no formato 0.00 ou 0,00
                            (somente dígitos, sem %)</li>
                        <li><b>csll:</b> Alíquota % imposto CSLL sobre a NF faturada do job no formato 0.00 ou
                            0,00 (somente dígitos, sem %)</li>
                        <li><b>data_vencimento_nf:</b> Data de vencimento da nota fiscal no formato DD/MM/AAAA
                        </li>
                    </ul>

                    <b>Campos opcionais:</b> arquivo pode opcionalmente conter:
                    <ul>
                        <li><b>data_recebimento:</b> Data de recebimento da nota fiscal no formato DD/MM/AAAA</li>
                    </ul>
                    <b>Outros campos/colunas:</b> arquivo pode conter outros campos mas ele serão ignorados
                    <b>Linhas com erros: </b>arquivo não pode conter erros. Ao enviar um arquivo se houver falha
                    o arquivo não será processado. Será gerada uma mensagem de erro para o primeiro erro
                    encontrato no arquivo indicado a linha do erro a uma mensagem indicando o problema ocorrido.
                    O arquivo deve ser corrigido (consertando ou removendo a linha com problemas) e deve ser
                    importado novamente novamente.<br><br>
                    <b>Registros repetidos:</b>o sistema não verifica se um retorno de faturamento existente no
                    arquivo é repetido ou mesmo se já foi importado antes. O sistema simplesmente irá
                    sobrescrever a data de faturamento com a data informada no último arquivo de
                    importação.<br><br><b>Ex.</b> se alguém fizer uma importação hoje e nela tiver o faturmento do
                    job 1, com data de emissão da nota fiscal igual a 01/01/2019 isso marcará a data de
                    faturamento com a data 01/01/2019. Se alguns dias depois um novo arquivo for importado e
                    contiver <b>novamente</b> uma linha com job 1 e data de emissão da nota fiscal igual a
                    15/01/2019, este job passará ter a nova data de faturamento (15/01/2019) e a data anterior
                    será perdida.

                </div>
            </div>
            <div v-if="filesFaturamento.length" class="files">
                <div class="upload row align-center grid-12">Upload <Button :loader="loader"
                        v-if="filesFaturamento.length > 0 && filesFaturamento.filter(f => f.notallow).length == 0"
                        @click="submit('filesFaturamento')" layout="green-go">ENVIAR</Button></div>
                <div v-for="(f, i) in filesFaturamento" :key="'fat'+i" class="file row align-center">
                    <button @click="filesFaturamento.splice(i, 1)" class="del" title="Excluir"><i
                            class="fa fa-trash" /></button>
                    <div v-if="!f.notallow" class="field grid-8 grid-6-s">
                        <div class="filler row justify-end" :style="`width: ${f.percent}%`"> {{ f.percent + "%" }}</div>
                    </div>
                    <div v-else class="notallow">{{ f.notallow && 'Formato de arquivo não permitido.' }}</div>
                    {{ f.name }}
                </div>
            </div>
            <div v-if="faturamento.length" class="list">
                <div class="head row">
                    <div class="grid-2">ID</div>
                    <div class="grid-3">Tipo</div>
                    <div class="grid-6">Criado</div>
                    <div class="grid-2"></div>
                </div>
                <div class="container">
                    <div v-for="f of faturamento" :key="f.id" class="line row align-center">
                        <div class="grid-2">{{ f.id }}</div>
                        <div class="grid-3">{{ f.tipo }}</div>
                        <div class="grid-6">{{ f.nome_criado_por }} em {{ f.criado_em | date }}</div>
                        <div class="grid-2 text-center"><Button layout="green-go" @click="open(f.id, 'faturamento')"><i
                                    class="fa fa-file" />Baixar</Button></div>
                    </div>
                </div>
            </div>
        </div>
        <input id="attach" type="file" ref="files" @change="loadFile" class="hide" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";

export default {
    name: "Imports",
    components: { Button },
    data() {
        return {
            loader: false,
            tutorial: false,
            tutorialFaturamento: false,
            filesPagamento: [],
            filesFaturamento: [],
            pagamento: [],
            faturamento: [],
            up: "",
            file: []
        };
    },
    methods: {
        ...mapActions("admin", ["LISTAR_RETORNO", "UPLOAD_RETORNO", "GET_RETORNO"]),
        async list(m) {
            this.loader = true
            await this.LISTAR_RETORNO(m).then(({ data }) => this[m] = data || [])
            this.loader = false
        },
        open(ID, tipo) {
            this.GET_RETORNO(ID).then(({ data }) => {
                let file = ""
                if (data.csv) {
                    data.csv.map(c => file += `${c.join(";")}\n`)
                    const blob = new Blob([file], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `retorno-${tipo}-${data.criado_em.slice(0, 10)}`;
                    a.click();
                }
            })
        },
        load(p) {
            this.up = p
            document.getElementById('attach').click()
        },
        loadFile(f) {
            var files = f.target.files || f.dataTransfer.files;
            this.file = files
            for (let i = 0; i < files.length; i++) {
                if (!this[this.up][i]) this[this.up][i] = { percent: 0, name: files[i].name }
                if (files[i].type.match("text/csv")) {
                    let reader = new FileReader();
                    reader.readAsDataURL(files[i]);
                    reader.onprogress = (e) => {
                        if (e.lengthComputable) {
                            this[this.up][i].percent = Math.round((e.loaded / e.total) * 100)
                            this[this.up] = [...this[this.up]]
                        }
                    }
                    reader.onload = (e) => {
                        this[this.up][i].file = e.target.result;
                        this[this.up][i].percent = 100;
                        this[this.up] = [...this[this.up]];
                    }
                } else
                    this[this.up][i].notallow = true
            }
        },
        async submit(v) {
            var formData = new FormData();
            formData.append("arquivo", this.file[0]);
            this.loader = true;
            await this.UPLOAD_RETORNO({ t: v == 'filesPagamento' ? 'pagamento' : 'faturamento', file: formData })
            this.loader = false;
            this[v] = []
        },
    },
    mounted() { this.$parent.$children[0].changeMenu("retorno") }
};
</script>

<style lang="sass" scoped>
  @use "@/assets/scss/vars.scss" as *
  .imports
      @include page
      .mod
        padding: 6px 12px
        background: white
        border-radius: 8px
        margin-top: 25px
        @include border
        .title
            padding: 12px 6px
            font-size: 21px
            img
                width: 25px
                margin-left: 6px
            .tut
                font-size:14px
                margin-left: 12px 
                color: $blue-2
                background: none
        .tutorial
            background: #f1f1f1
            border-radius: 12px
            padding: 20px 12px
            img
                border-radius: 8px
            .step
                border-radius: 6px
                background: #f1f1f1
                padding: 10px
                margin: 0 4px
                font-weight: bold
                @include border
                margin-bottom: 20px
                .st
                    color: $orange-1
                    font-size: 21px
                    margin-bottom: 10px
                img
                    margin-top: 10px
                    width: 100%
            .title
                color: $blue-2
                font-size: 23px
                margin-bottom: 10px
                font-weight: bold
            .desc
                padding: 12px
                font-size: 14px
                label, b
                    font-size: 17px
                    color: $blue-2
                ul
                    margin: 12px
        .files
            margin-top: 25px
            font-size: 14px
            color: $font-color
            border-radius: 12px
            @include border()
            button
                font-size: 11px
                margin-left: 10px
                margin-top: 2px
            .upload
                font-size: 24px
                color: $green
                margin: 8px 12px
            .file
                padding: 10px
                &:nth-child(even)
                    background: #f1f1f1
                .del
                    color: #666
                    font-size: 16px
                    background: none
                    margin-right: 8px
                    margin-left: -2px
                    &:hover
                        color: $red
                .notallow
                    color: $red-1
                    font-size: 11px
                    margin-right: 10px
            .field 
                height: 15px
                width: 200px
                background: #444
                border: 1px solid #dbdbdb
                border-radius: 50px
                overflow: hidden
                margin-right: 10px
                .filler 
                    height: 100%
                    font-weight: bold
                    background: linear-gradient(90deg, $green-6 0%, $green-2 50%)
        .list
            padding: 0
            overflow: hidden
            border-radius: 6px
        .head
            font-size: 16px
            color: white
            background: rgba($blue-2, .5)
            border-bottom: 1px solid $blue-2
            padding: 8px 5px
        .container
            max-height: 500px
            overflow: auto
            .line
                padding: 12px 5px
                font-size: 14px
                color: $gray-2
                &:hover
                 background: rgba($purple, .5)

  </style>